import {
  html
} from 'lit';

export default html`
<svg xmlns="http://www.w3.org/2000/svg"    viewBox="0 0 256 256"><path d="M155.52,24.81a8,8,0,0,0-8.43.88L77.25,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A7.94,7.94,0,0,0,152,232a8,8,0,0,0,8-8V32A8,8,0,0,0,155.52,24.81Z"></path></svg>
`;
